module.exports = __webpack_public_path__ + "8955c197565599adb28a3b2ecd6b0932.bg.png";


//////////////////
// WEBPACK FOOTER
// ./components/featuredEvents/assets/bg.png
// module id = OoNg
// module chunks = 0